export default __webpack_public_path__ + "static/media/menu-filters.60c05108.svg";